module.exports = __webpack_public_path__ + "img/Extra550.58718a33.png";